import React from 'react'
import MainInvoice from '../Views/Web/Invoice/MainInvoice'
import { IndexInvoiceOutgoing, InvoiceOutgoingCreate, InvoiceOutgoingEdit, InvoiceOutgoingMain, InvoiceOutgoingView } from '../Views/Web/Invoice/InvoiceOutgoing'
import { Route } from 'react-router-dom'

function InvoiceRoutes() {
  return (
        <Route path="invoice" element={<MainInvoice />}>
            <Route path="invoice-outgoing" element={<InvoiceOutgoingMain/>} >
             <Route index element={<IndexInvoiceOutgoing/>} />
             <Route path='create' element={<InvoiceOutgoingCreate/>} />
             <Route path='edit/:invoiceOutgoingEditId' element={<InvoiceOutgoingEdit/>} />
             <Route path='view/:invoiceOutgoingViewId' element={<InvoiceOutgoingView/>} />
            </Route>
            
        </Route>
      )
}

export default InvoiceRoutes